<template>
  <v-layout justify-center>
    <v-flex>
      
      <v-container fluid class="ma-0">
        <v-layout row wrap>
          <v-flex>
              <iframe
                id="frm_window"
                frameborder="0"
                :src="iframe.url"
                width="100%"
                :height="iframe.height"
								scrolling="no"
              ></iframe>
          </v-flex>
        </v-layout>
      </v-container>
      
    </v-flex>
  </v-layout>
</template>

<script>
import auth from "../../functions/auth";
import common from "../../functions/general";

export default {
  name: "iFrameFull",
  // components: {
  //   Breadcrumbs: Breadcrumbs
  // },
  data: () => ({
    iframe: {
      // visible: false,
      url: "",
			height: "1200px",
    }
  }),
  mounted: function() {
    // this.initial();
    var menu = auth.getMenu().concat(auth.getMenu_int());
    // var pageID = common.App.get_pageID();
        
    // var card = menu.filter(function(AppMenu) {
    //   return AppMenu.id == pageID;
    // });

    var pageUUID = common.App.get_pageUUID();
        
    var card = menu.filter(function(AppMenu) {
      return AppMenu.uuid == pageUUID;
    });

		this.iframe.url = card[0].component_path.iframe_path;

    
    if (card[0].component_path.iframe_height) {
      this.iframe.height = card[0].component_path.iframe_height;
    }
		
  }
};
</script>

<style>
</style>